<template>
  <b-dropdown :triggers="['hover']" aria-role="list" position="is-bottom-left">
    <template #trigger>
      <button class="button" :class="status" slot="trigger" @click.stop>
        {{
          status === "received"
            ? "Recebido"
            : status === "confirmed"
            ? "Confirmado"
            : status === "inPreparation"
            ? "Em preparação"
            : status === "ready"
            ? "Pronto"
            : status === "beingDelivered"
            ? "Em entrega"
            : status === "delivered"
            ? "Entregue"
            : status === "cancelled"
            ? "Cancelado"
            : "Sem status"
        }}
      </button>
    </template>

    <b-dropdown-item aria-role="listitem">
      <button
        class="button is-info confirmed"
        @click="changeOrderStatus('confirmed')"
        :disabled="
          [
            'confirmed',
            'inPreparation',
            'ready',
            'beingDelivered',
            'delivered',
            'cancelled'
          ].includes(status)
        "
      >
        1 - Confirmar pedido
      </button>
      <br /><br />

      <button
        class="button is-info inPreparation"
        @click="changeOrderStatus('inPreparation')"
        :disabled="
          [
            'inPreparation',
            'ready',
            'beingDelivered',
            'delivered',
            'cancelled'
          ].includes(status)
        "
      >
        2 - Iniciar preparo
      </button>
      <br /><br />

      <button
        class="button is-info ready"
        @click="changeOrderStatus('ready')"
        :disabled="
          ['ready', 'beingDelivered', 'delivered', 'cancelled'].includes(status)
        "
      >
        3 - Pedido pronto
      </button>
      <br /><br />

      <button
        class="button is-info delivered"
        @click="changeOrderStatus('delivered')"
        :disabled="['delivered', 'cancelled'].includes(status)"
      >
        4 - Pedido entregue
      </button>
      <br />
      <hr />

      <button
        class="button is-danger"
        @click="changeOrderStatus('cancelled')"
        :disabled="['cancelled'].includes(status)"
      >
        Pedido cancelado
      </button>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { common } from "../../../mixins/common";

export default {
  props: ["status", "transactionId"],

  mixins: [common],

  methods: {
    changeOrderStatus(status) {
      this.$emit("loading", true);
      this.$store
        .dispatch("changeOrderStatus", {
          transactionId: this.transactionId,
          status
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.$emit("get-transactions");
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.$emit("loading", false);
        });
    }
  }
};
</script>

<style scoped>
.received {
  background-color: white;
  color: #121212;
}
.confirmed {
  background-color: #eccfc8;
  color: #121212;
}
.inPreparation {
  background-color: #e7a696;
  color: #121212;
}
.ready {
  background-color: #e5846b;
  color: #121212;
}
.beingDelivered {
  background-color: #e36f52;
  color: white;
}
.delivered {
  background-color: #f0512d;
  color: white;
}
.cancelled {
  background-color: #c1c1c1;
  color: #454545;
}
</style>
